import indexedDB from './indexedDBWrapper';
import localStorage from './localStorageWrapper';

export async function openIndexedDB() {
  return new Promise((resolve, reject) => {
    try {
      const idbConn = window.indexedDB.open('checkIndexedDB');
      idbConn.onsuccess = resolve;
      idbConn.onerror = reject;
    } catch (e) {
      reject();
    }
  });
}

export async function getCompatibleStorage(
  isFirefox: boolean = navigator.userAgent.includes('Firefox')
) {
  if (window.indexedDB) {
    if (!isFirefox) {
      return indexedDB;
    }
    // Firefox has issue on indexedDB in private mode
    // https://github.com/TinderApp/TinderWeb/pull/1621
    // https://bugzilla.mozilla.org/show_bug.cgi?id=781982
    try {
      await openIndexedDB();
    } catch (e) {
      return localStorage;
    }

    return indexedDB;
  }
  return localStorage;
}
